import { HeaderFilterBox, CustomTextField } from '../../../common';

const dateFieldStyles = {
  width: { xs: '100%', sm: '48%', md: '18%' },
  mb: { xs: 1.5, md: 0 },
};

const DebtNotificationsFilters = ({ filter, onDateChange, onDatePreset, onResetFilters }) => {
  return (
    <>
      <HeaderFilterBox>
        <CustomTextField
          label="Desde"
          id="notifications-from-date"
          name="fromDate"
          type="date"
          value={filter.fromDate}
          onChange={onDateChange}
          sx={{ marginRight: 2, ...dateFieldStyles }}
          size="medium"
          InputLabelProps={{ shrink: true }}
        />

        <CustomTextField
          label="Hasta"
          id="notifications-to-date"
          name="toDate"
          type="date"
          value={filter.toDate}
          onChange={onDateChange}
          sx={dateFieldStyles}
          size="medium"
          InputLabelProps={{ shrink: true }}
        />
      </HeaderFilterBox>
    </>
  );
};

export default DebtNotificationsFilters;

